module.exports = __webpack_public_path__ + "img/triple fairy strafing run.81251872.png";